import React from 'react';
import loading from './loading.gif';

const Loading = () => (
    <div className="row">
        <div className="col-md-2 col-md-offset-5">
            <img src={loading} alt="loading icon" />
        </div>
    </div>
);

export default Loading;